module.exports = __webpack_public_path__ + "static/media/AreaMeasurement_002.64971f57.jpg";